var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.series[0].data.length)?_c('dashboard-chart',{attrs:{"title":"Top audience par article","type":"bar","series":_vm.series,"categories":[],"chartOptions":_vm.dashboardMainChartOptions,"outlined":"","loading":_vm.loading}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }